module.exports = __webpack_public_path__ + "static/media/comment-video.e676f25a.svg";